export default {
  SET_PROFILE(state, whatsappProfile) {
      state.whatsappProfile = whatsappProfile
  },
  UPDATE_PROFILE(state, whatsappProfile) {
      Object.assign(state.whatsappProfile, whatsappProfile)
  }
}
